<h2 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Add Contact
</h2>

<mat-dialog-content class="dialog-content">
    <div>
        <mat-form-field appearance="outline" class="input">
            <mat-label>Name</mat-label>
            <input matInput [required]="isRequired('Name')" [(ngModel)]="ContactName" pattern="^\S.*\S$" #nameInput="ngModel" />
            @if (nameInput.invalid && (nameInput.dirty || nameInput.touched)) {
            <mat-error>
                @if (nameInput.errors?.['pattern']) {
                <span>Must enter a name</span>
                }
            </mat-error>
            }
        </mat-form-field>
    </div>

    <div>
        <mat-form-field appearance="outline" class="input">
            <mat-label>Email</mat-label>
            <input matInput type="text" [required]="isRequired('Email')" [(ngModel)]="Email" name="email" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" #emailInput="ngModel">
            @if (emailInput.invalid && (emailInput.dirty || emailInput.touched)) {
            <mat-error>
                @if (emailInput.errors?.['pattern']) {
                <span>Not a valid email</span>
                }
            </mat-error>
            }
        </mat-form-field>
    </div>

    <div>
        <mat-form-field appearance="outline" class="input">
            <mat-label>Phone</mat-label>
            <input matInput [required]="isRequired('Phone')" [(ngModel)]="Phone" pattern="^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$" #phoneInput="ngModel" />
            @if (phoneInput.invalid && (phoneInput.dirty || phoneInput.touched)) {
            <mat-error>
                @if (phoneInput.errors?.['pattern']) {
                <span>Not a valid phone number</span>
                }
            </mat-error>
            }
        </mat-form-field>
    </div>

    <div>
        <mat-form-field appearance="outline" class="input">
            <mat-label>Agency</mat-label>
            <input matInput [required]="isRequired('Agency')" [(ngModel)]="Agency" #agencyInput="ngModel" />
            @if (agencyInput.dirty || agencyInput.touched) {
            <mat-error>
                @if (phoneInput.errors?.['pattern']) {
                <span>huh?</span>
                }
            </mat-error>
            }
        </mat-form-field>
    </div>

    <div class="is-primary">
        <mat-checkbox [(ngModel)]="isPrimaryContact">Is this user the primary contact?</mat-checkbox>
    </div>

    <app-max-picker class="max-picker-component"
                    [maxMemberStyle]="'width: 70%;'"
                    [addButtonName]="'Set User'"
                    [scope]="'usersOnly'"
                    (addButtonClicked)="onUserSet($event)">
    </app-max-picker>

    @if(DummyFormInstance){
    <app-form-renderer [embedded]="true"
                       [formInstance]="DummyFormInstance"
                       [mode]="'instance'"
                       [form]="this.DummyFormInstance.form"
                       [buttonsEnabled]="true"
                       (onInit)="this.handleFormRendererInitialized($event)"
                       (validityStatus)="this.handleValidityStatus($event)">
    </app-form-renderer>
    }

</mat-dialog-content>

<mat-dialog-actions class="actions-bar">
    <button mat-flat-button
            [disabled]="!(nameInput.valid && emailInput.valid && phoneInput.valid && agencyInput.valid) || HasInvalidExtraFields"
            color="primary"
            class="theme-primary-btn"
            (click)="closeDialog(true)">
        Ok
    </button>
    <button mat-flat-button style="margin-left: 10px;" (click)="closeDialog(false)">Cancel</button>
    @if(HasInvalidExtraFields){<span style="color:red">Correct validation errors</span>}
</mat-dialog-actions>

